<template>
  <el-dialog
    :close-on-click-modal="false"
    title="拆分产品项"
    :visible.sync="visible"
    width="1000px"
    top="5vh"
    class="divideOrder"
    :before-close="handleClose"
  >
    <div style="max-height: 69vh;overflow: auto;">
      <div class="line">
        <span class="title">产品名称：</span>
        {{ order.proName }}
      </div>
      <div class="line">
        <span class="title">产品数量：</span>
        {{ diviceCnt }}
      </div>
      <div class="line">
        <span class="title">产品拆分：</span>
        <el-input
          v-model="diviceCnt"
          class="input"
          size="small"
          :min="1"
          type="number"
          style="width: 80px;"
          @change="divideOrder"
        />
        <span style="margin: 0 10px;">项</span>
      </div>
      <br />
      <div class="table">
        <div class="top">
          <div class="item">
            <div class="left">编号</div>
            <div class="right">产品信息</div>
          </div>
          <div class="item" v-if="diviceCnt >= 2">
            <div class="left">编号</div>
            <div class="right">产品信息</div>
          </div>
        </div>
        <div class="table-list">
          <div class="item" v-for="(item, index) in ordersData" :key="index">
            <div class="index">{{ index + 1 }}</div>
            <div class="content">
              <div class="left">
                <img :src="item.picUrl ? item.picUrl : noImage" alt="" />
              </div>
              <div class="right">
                <div class="title">
                  <div class="name" style="float:left;    margin: 4px 0 0 0;">
                    成品编号：
                  </div>
                  <div class="value" style="float:left;">
                    <el-input
                      v-model="item.designId"
                      class="input"
                      size="small"
                      @change="getTargetItem(index)"
                      @keyup.enter="getTargetItem(index)"
                      style="width: 230px;"
                    />
                  </div>
                </div>

                <div class="list">
                  <div class="name">颜色：</div>
                  <div class="value" v-if="item.attribute">
                    <el-select
                      clearable
                      v-model="item.color"
                      class="input"
                      size="small"
                      @change="changeProper(item)"
                    >
                      <el-option
                        v-for="(value, index) in JSON.parse(item.attribute)[
                          '颜色'
                        ]"
                        :key="index"
                        :label="value"
                        :value="value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="list">
                  <div class="name">尺码：</div>
                  <div class="value" v-if="item.attribute">
                    <el-select
                      clearable
                      v-model="item.size"
                      class="input"
                      size="small"
                      @change="changeProper(item)"
                    >
                      <el-option
                        v-for="(value, index) in JSON.parse(item.attribute)[
                          '尺码'
                        ]"
                        :key="index"
                        :label="value"
                        :value="value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="list">
                  <div class="name">数量：</div>
                  <div class="value">
                    <el-input
                      @change="caculateCount"
                      v-model="item.num"
                      class="input"
                      size="small"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="line pd10">
          <span class="title">当前合计：</span>
          {{ count }}件，（原产品总数：{{ order.num }}件）
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">取消</el-button>
      <el-button type="primary" @click="sure" size="small">
        保存
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { splitSku } from "@/api/order/all"
import { getCartInfo, getCartMatchInfo } from "@/api/customProduct/design"

import noImage from "@/assets/images/no_image.png"

export default {
  name: "DivideOrder",
  data() {
    return {
      diviceCnt: 2,
      ordersData: [],
      appSkuId: "",
      count: 0,
      noImage: noImage,
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    order: {
      type: Object,
      default() {
        return {}
      },
    },
    currentOrderSku: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  watch: {
    currentOrderSku() {
      this.diviceCnt = 2
      this.getData()
    },
  },
  methods: {
    async getData() {
      if (this.order.designId) {
        this.appSkuId = this.order.appSkuId
        let result = await getCartMatchInfo(this.order.designId)
        let record = result.data[0]
        record.color = this.order.properVal.split(":")[0]
        record.size = this.order.properVal.split(":")[1]
        record.num = this.order.num
        record.picUrl = this.order.picUrl
        this.changeProper(record)

        this.ordersData = []
        for (let i = 0; i < 2; i++) {
          let data = this._.clone(record)
          this.ordersData.push(data)
        }
        this.caculateCount()
      }
    },
    async divideOrder() {
      if (this.diviceCnt > this.ordersData.length) {
        for (let i = 0; i < this.diviceCnt - this.ordersData.length; i++) {
          let result = await getCartMatchInfo(this.order.designId)
          let record = result.data[0]
          record.color = this.order.properVal.split(":")[0]
          record.size = this.order.properVal.split(":")[1]
          record.num = this.order.num
          record.picUrl = this.order.picUrl
          this.changeProper(record)
          let data = this._.clone(record)
          this.ordersData.push(data)
        }
      }

      if (this.diviceCnt < this.ordersData.length) {
        this.ordersData = this.ordersData.slice(0, this.diviceCnt)
      }
      this.caculateCount()
    },
    changeProper(item) {
      for (let record of item.skuList) {
        if (record.properVal === `${item.color}:${item.size}`) {
          item.skuId = record.skuId
          item.picUrl = record.picList[0].picUrl
          break
        }
      }
    },
    sure() {
      let form = []
      for (let record of this.ordersData) {
        form.push({
          appSkuId: this.appSkuId,
          skuId: record.skuId,
          num: record.num,
        })
        if (!record.skuId) {
          this.$message.error("请选择SKU")
          return
        }
        if (!record.num) {
          this.$message.error("请选择数量")
          return
        }
      }

      splitSku(form)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("拆分成功")
            this.$emit("onClose")
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((error) => {
          this.$message.error(error.msg)
        })
    },
    caculateCount() {
      let count = 0
      for (let record of this.ordersData) {
        count += Number(record.num)
      }
      this.count = count
    },
    handleClose() {
      this.$emit("onClose")
    },
    async getTargetItem(index) {
      try {
        let result = await getCartMatchInfo(this.ordersData[index].designId)
        if (result.data.length > 0) {
          result.data[0].picUrl = result.data[0].skuList[0].mainPic.picUrl
          result.data[0].num = this.ordersData[index].num
          this.ordersData[index] = result.data[0]
        } else {
          this.ordersData[index] = {}
        }
        this.ordersData = this._.clone(this.ordersData)
      } catch (error) {}
    },
  },
}
</script>

<style scoped>
.pd10 {
  padding: 5px 10px;
  border-top: 1px solid #ebeef5;
}

.divideOrder {
  font-size: 12px;
}

.divideOrder .line {
  display: flex;
  height: 30px;
  align-items: center;
}

.divideOrder .line .title {
  width: 60px;
}

.table {
  border: 1px solid #ebeef5;
}

.table .top {
  display: flex;
  background: #f5f7fa;
  height: 36px;
  align-items: center;
}

.table .top .item {
  width: 50%;
  display: flex;
}

.table .top .item .left {
  width: 50px;
  text-align: center;
}

.table .top .item .right {
  width: 328px;
  text-align: center;
}

.table .table-list {
  display: flex;
  flex-wrap: wrap;
}

.table .table-list .item {
  width: 50%;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  border-bottom: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}

.table .table-list .item:nth-child(2n) {
  border-right: 0;
}

.table .table-list .item:nth-last-child(2),
.table .table-list .item:last-child {
  border-bottom: 0;
}

.table .table-list .item .index {
  width: 40px;
  text-align: left;
  box-sizing: border-box;
  padding-left: 10px;
}

.table .table-list .item .content {
  display: flex;
}

.table .table-list .item .content .left {
  width: 100px;
  height: 100px;
  margin-right: 10px;
  border: 1px solid #ebeef5;
}

.table .table-list .item .content .left img {
  width: 100%;
  height: 100%;
}

.table .table-list .item .content .right {
  display: flex;
  flex-direction: column;
}

.table .table-list .item .content .right .title {
  font-size: 14px;
  margin-bottom: 10px;
  overflow: hidden;
}

.table .table-list .item .content .right .list {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  width: 300px;
}

.table .table-list .item .content .right .list .name {
  width: 90px;
}

.table .table-list .item .content .right .list .value {
  width: 100%;
}
</style>
